/** Claro por defecto; oscuro solo si el usuario lo eligió (clase `dark` en <html>, persistida). */
const KEY = 'planning.theme';
export type ThemeMode = 'light' | 'dark';
export function getThemeMode(): ThemeMode {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}
export function applyTheme(mode: ThemeMode = getThemeMode()) {
  document.documentElement.classList.toggle('dark', mode === 'dark');
}
export function setThemeMode(mode: ThemeMode) {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* modo privado */
  }
  applyTheme(mode);
}
